import React from 'react';
import { formatISO } from 'date-fns';
import EventContent from '../content/EventContent';
import {useEvent} from '../../../api/hooks';
import Loader from '../Loader';
import PageNotFound from '../PageNotFound';
import Error from '../Error';

export const EventSelector = ({match, children}) => {
    const {data: event, isLoading, error} = useEvent(match.params.id, {
        // By default the backend only includes event dates that end tomorrow or after. However we also want to show
        // the event date of today, if there is one, so we overwrite this setting.
        'date_scope_from': formatISO(new Date(), { representation: 'date' }),
    });

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return children({event});
};

export default ({match}) => (
    <EventSelector match={match}>
        {({event}) => (
            <>
                {event.error || event.code ? <PageNotFound error={event} />
                    :
                    <>
                        <EventContent event={event} />
                    </>
                }
            </>
        )}
    </EventSelector>
);
